<template>
	<div class="page">
		<HeaderBar title="甲/丙/丁/戊/HIV抗体"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400jbdkt.guid">
					<FormNormalInput label="甲肝抗体" v-model="form.bq400jbdkt.bq4001122" readonly />
					<FormNormalInput label="丙肝抗体" v-model="form.bq400jbdkt.bq4001132" readonly />
					<FormNormalInput label="丁肝抗体" v-model="form.bq400jbdkt.bq4001153" readonly />
					<FormNormalInput label="戊肝抗体" v-model="form.bq400jbdkt.bq4001142" readonly />
					<FormNormalInput label="HIV抗体" v-model="form.bq400jbdkt.bq4001152" readonly />
				</van-cell-group>
				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq400jbdkt.guid' disabled>
				</FormNormalUpload>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page009",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400jbdkt',
				form: {
					bq400jbdkt: {
						id: "", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq4001122: "未查", //甲肝抗体
						bq4001132: "未查", //丙肝抗体
						bq4001142: "未查", //戊肝抗体
						bq4001152: "未查", //HIV抗体
						bq4001153: "未查", //丁肝抗体
						Bq400_guid: '', //随访基本信息表编号
						Bq400_112_2: '', //甲肝抗体
						Bq400_113_2: '', //丙肝抗体
						Bq400_114_2: '', //戊肝抗体
						Bq400_115_2: '', //HIV抗体
						Bq400_115_3: '', //丁肝抗体
					},
					sempFiles: []
				},
				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400jbdkt/Save',
				bq400: JSON.parse(sessionStorage.getItem('bq400'))
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400jbdkt/Info', args, function(d) {
					let dataModel = d.Data
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$utils.CopyPro(dataModel, that.form.bq400jbdkt)
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			this.form.bq400jbdkt.bq400guid = this.bq400.guid
			this.LoadInfo()
		}
	}
</script>

<style scoped>

</style>
